export default function debounce(fn, _isMounted, timer, delayFactor) {
  const delay = (delayFactor || 0) * 100;
  if (timer) clearTimeout(timer);
  if (_isMounted.current) {
    return setTimeout(() => {
      fn();
    }, delay);
  }
}
